// TV 색 보정 사용 여부. 켜면 main.tsx 가 <html> 에 `tv-color-correction` 클래스를 붙이고,
// 실제 보정은 global.css 의 `html.tv-color-correction` 규칙이 한다.
// 연결한 화면(기기)마다 다른 문제라 계정이 아닌 localStorage 에 둔다.
const TV_COLOR_CORRECTION_LOCAL_STORAGE_KEY = "tv-color-correction";

let cachedTvColorCorrectionEnabled: boolean | null = null;

const readTvColorCorrectionEnabled = (): boolean =>
  typeof localStorage !== "undefined" &&
  localStorage.getItem(TV_COLOR_CORRECTION_LOCAL_STORAGE_KEY) === "true";

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === TV_COLOR_CORRECTION_LOCAL_STORAGE_KEY) {
      cachedTvColorCorrectionEnabled = null;
    }
  });
}

export const isTvColorCorrectionEnabled = (): boolean => {
  if (cachedTvColorCorrectionEnabled === null) {
    cachedTvColorCorrectionEnabled = readTvColorCorrectionEnabled();
  }
  return cachedTvColorCorrectionEnabled;
};

export const setTvColorCorrectionEnabled = (enabled: boolean): void => {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(TV_COLOR_CORRECTION_LOCAL_STORAGE_KEY, String(enabled));
  cachedTvColorCorrectionEnabled = enabled;
};
